import { render, staticRenderFns } from "./SendTechnology.vue?vue&type=template&id=1d6f2d80&scoped=true&"
import script from "./SendTechnology.vue?vue&type=script&lang=js&"
export * from "./SendTechnology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6f2d80",
  null
  
)

export default component.exports